import React, { useContext, useState } from 'react'
import { useParams, useRouter } from 'next/navigation'
import routes from '@routes'
import Grid from '@ui/Grid'
import Box from '@ui/Box'
import { pathToUrl } from '@utils/router'
import { BuilderContext } from './utils'
import Flex from '@ui/Flex'
import { saveWidget } from '@api/widgets'
import { Input } from 'antd'
import { HiOutlineTemplate } from 'react-icons/hi'
import { MdArrowBack, MdQuestionAnswer } from 'react-icons/md'
import IconButton from '@ui/IconButton'
import { BsPencilFill } from 'react-icons/bs'
import MenuButton from '@ui/MenuButton'
import { VscVersions } from 'react-icons/vsc'
import { AiOutlineCheck } from 'react-icons/ai'
import styled from 'styled-components'
import { CiViewTable } from 'react-icons/ci'
import { IoAnalytics, IoSettingsOutline } from 'react-icons/io5'
import { IoIosLink } from 'react-icons/io'
import GotIdeaButton from '@components/GotIdeaButton/GotIdeaButton'
import AiWizard from '@components/AIWizard/AIWizard'

const Wrap = styled(Box)`
  width: 160px;
  overflow: hidden;

  @media (max-width: 480px) {
    width: 40px;
  }
`

const NameWrap = styled(Box)`
  display: block;

  @media (max-width: 980px) {
    display: none;
  }
`

const BackLabel = styled.span`
  @media (max-width: 480px) {
    display: none;
  }
`

type Props = {}

const BuilderSideMenu = () => {
  const { widget, setWidget } = useContext(BuilderContext)
  const params = useParams()
  const id = params!.id
  const router = useRouter()

  const isDemo = widget.id === 'demo'

  const [nameEditing, setNameEditing] = useState(false)

  return (
    <Wrap p={8} flexShrink={0}>
      <Flex flexDirection="column" justifyContent="space-between" height="100%">
        <Grid gap={8}>
          {!isDemo && (
            <Box mb={16}>
              <IconButton
                icon={MdArrowBack}
                iconSize={16}
                onClick={() => router.push(routes.privateRoutes.platform.widgetList)}
                type="link"
              >
                <BackLabel>Back</BackLabel>
              </IconButton>
            </Box>
          )}

          <NameWrap>
            {nameEditing ? (
              <Grid flow="column" gap={8} alignItems="center">
                <Input
                  value={widget.name}
                  onChange={e =>
                    setWidget({
                      ...widget,
                      name: e.target.value,
                    })
                  }
                  placeholder="Enter a widget name"
                />
                <IconButton
                  icon={AiOutlineCheck}
                  onClick={() => {
                    setNameEditing(false)
                    saveWidget(widget)
                  }}
                />
              </Grid>
            ) : (
              <Flex alignItems="center">
                <Box
                  style={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  }}
                  maxWidth={105}
                >
                  {widget.name}&nbsp;&nbsp;
                </Box>

                {!isDemo && (
                  <IconButton
                    icon={BsPencilFill}
                    shape="circle"
                    iconSize={14}
                    onClick={() => setNameEditing(true)}
                    center
                  />
                )}
              </Flex>
            )}
          </NameWrap>

          <MenuButton
            icon={HiOutlineTemplate}
            to={pathToUrl(routes.privateRoutes.builder.templates, { id })}
          >
            Templates
          </MenuButton>

          <MenuButton
            icon={VscVersions}
            to={pathToUrl(routes.privateRoutes.builder.cards, { id })}
          >
            Cards
          </MenuButton>

          <MenuButton
            icon={CiViewTable}
            to={pathToUrl(routes.privateRoutes.builder.planComparison, { id })}
          >
            Compare plans
          </MenuButton>

          <MenuButton
            icon={MdQuestionAnswer}
            to={pathToUrl(routes.privateRoutes.builder.faqSection, { id })}
          >
            FAQ section
          </MenuButton>

          <MenuButton
            icon={IoSettingsOutline}
            to={pathToUrl(routes.privateRoutes.builder.settings, { id })}
          >
            Settings
          </MenuButton>

          <MenuButton
            icon={IoAnalytics}
            to={pathToUrl(routes.privateRoutes.builder.analytics, { id })}
          >
            Analytics
          </MenuButton>

          <MenuButton
            icon={IoIosLink}
            to={pathToUrl(routes.privateRoutes.builder.integrations, { id })}
          >
            Integrations
          </MenuButton>
          {!isDemo && <AiWizard />}
        </Grid>

        <GotIdeaButton />
      </Flex>
    </Wrap>
  )
}

export default BuilderSideMenu
